/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SIEUploadQueue = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The SIEUploadQueue model module.
   * @module model/SIEUploadQueue
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SIEUploadQueue</code>.
   * @alias module:model/SIEUploadQueue
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>SIEUploadQueue</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SIEUploadQueue} obj Optional instance to populate.
   * @return {module:model/SIEUploadQueue} The populated <code>SIEUploadQueue</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AddedByUserID')) {
        obj['AddedByUserID'] = ApiClient.convertToType(data['AddedByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ClientIdentifier')) {
        obj['ClientIdentifier'] = ApiClient.convertToType(data['ClientIdentifier'], 'String');
      }
      if (data.hasOwnProperty('DateAdded')) {
        obj['DateAdded'] = ApiClient.convertToType(data['DateAdded'], 'Date');
      }
      if (data.hasOwnProperty('DateEnd')) {
        obj['DateEnd'] = ApiClient.convertToType(data['DateEnd'], 'Date');
      }
      if (data.hasOwnProperty('QueueStatusID')) {
        obj['QueueStatusID'] = ApiClient.convertToType(data['QueueStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('LastFeedback')) {
        obj['LastFeedback'] = ApiClient.convertToType(data['LastFeedback'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} AddedByUserID
   * @default 0
   */
  exports.prototype['AddedByUserID'] = 0;
  /**
   * @member {String} ClientIdentifier
   * @default ''
   */
  exports.prototype['ClientIdentifier'] = '';
  /**
   * @member {Date} DateAdded
   */
  exports.prototype['DateAdded'] = undefined;
  /**
   * @member {Date} DateEnd
   */
  exports.prototype['DateEnd'] = undefined;
  /**
   * @member {Integer} QueueStatusID
   * @default 0
   */
  exports.prototype['QueueStatusID'] = 0;
  /**
   * @member {String} LastFeedback
   * @default ''
   */
  exports.prototype['LastFeedback'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


